import { LOAD_DESTINATIONS_SUCCESS, UPDATE_DESTINATION_FIELD, LOAD_DESTINATION_BY_ID, LOAD_DESTINATION_BY_ID_SUCCESS, LOAD_DESTINATIONS, UPDATE_DESTINATION_SUCCESS, CREATE_DESTINATION_SUCCESS, Destination, REMOVE_DESTINATION_BY_ID, REMOVE_DESTINATION_BY_ID_SUCCESS, SORT_DESTINATIONS, DELETE_DESTINATION_SUCCESS, DELETE_DESTINATION, TEST_DESTINATION, TEST_DESTINATION_SUCCESS } from "./types";
import store from '../../store';
import axios from '../../lib/axios';
import config from '../../config/app-config.json';

export const emptyDestination = () => {
    return {
        type: CREATE_DESTINATION_SUCCESS,
        payload: null
    }
}

export const deleteDestination = id => {
    return (dispatch: any) => {
        dispatch({
            type: DELETE_DESTINATION,
            payload: null
        })
        axios.delete(`${config.serviceUrl}/destination/${id}`).then((response) => {
            dispatch({
                type: DELETE_DESTINATION_SUCCESS,
                payload: response.data
            })
        })
    }
}

// Only the latest test may write its result: an earlier, slower test must not
// replace the answer for the URL being tested now.
let latestTestId = 0;

export const testDestination = destination => {
    return (dispatch: any) => {
        const testId = ++latestTestId;
        dispatch({
            type: TEST_DESTINATION,
            payload: null
        })
        // Sent by our server (Lambda srecPanelTestDestination), not by the browser:
        // endpoints may refuse browser calls, and real leads come from our server.
        const payload = {
            type: destination.type,
            method: destination.method,
            url: destination.url,
            body: destination.body,
            headers: destination.headers
        };
        return axios.post(`${config.serviceUrl}/destination-test`, payload).then((response: any) => {
            if (testId !== latestTestId) return;
            dispatch({
                type: TEST_DESTINATION_SUCCESS,
                payload: response.data
            })
        }).catch((error: any) => {
            if (testId !== latestTestId) return;
            const status = error && error.response ? error.response.status : null;
            const data = error && error.response ? error.response.data : null;
            // 400/403 come from the test Lambda before it sends anything; any other
            // failure means we do not know whether the endpoint got the test.
            const refused = status === 400 || status === 403;
            const message = refused && data && data.message
                ? data.message
                : `Our server did not return a test result${status ? ` (HTTP ${status})` : ''}.`;
            dispatch({
                type: TEST_DESTINATION_SUCCESS,
                payload: { ok: false, status: null, sent: refused ? false : null, error: { code: 'TEST_REQUEST_FAILED', message } }
            })
        })
    }
}

export const updateDestinationField = (field, value) => {
    console.log('in updateDestinationField');
    return {
        type: UPDATE_DESTINATION_FIELD,
        payload: { field, value }
    }
}

export const loadDestinations = () => {
    return (dispatch: any) => {
        dispatch({
            type: LOAD_DESTINATIONS,
            payload: null
        })
        axios.get(`${config.serviceUrl}/destinations/`).then((response) => {
            dispatch({
                type: LOAD_DESTINATIONS_SUCCESS,
                payload: response.data.data
            })
        })
    }
}

// Product Events screen save.
//
// Why this is not just saveDestination: the deployed addDestination Lambda's
// INSERT has a fixed column list that does NOT include `paused`, so a row
// created while Paused would land Active and start delivering immediately.
// On CREATE we therefore POST, reload, find this client's product_view row
// (the list is already server-scoped to the selected client), and PUT the
// paused flag if it differs from what was asked for. UPDATE needs none of
// this — updateDestination does `SET ?` over the whole toUnderscore'd body.
export const saveProductEventsConfig = (destination: any) => {
    const body = { ...destination, api_key: destination.apiKey, custom_properties: destination.customProperties };
    const reload = (dispatch: any) => {
        dispatch({ type: LOAD_DESTINATIONS, payload: null });
        return axios.get(`${config.serviceUrl}/destinations`).then((response) => {
            dispatch({ type: LOAD_DESTINATIONS_SUCCESS, payload: response.data.data });
            return response.data.data;
        });
    };
    return (dispatch: any) => {
        if (body.id) {
            delete body.triggerId;
            return axios.put(`${config.serviceUrl}/destination/${body.id}`, body).then((response) => {
                dispatch({ type: UPDATE_DESTINATION_SUCCESS, payload: response });
                return reload(dispatch);
            });
        }
        return axios.post(`${config.serviceUrl}/destination`, body).then((response: any) => {
            dispatch({ type: CREATE_DESTINATION_SUCCESS, payload: response });
            return reload(dispatch).then((rows: any) => {
                const wanted = Number(body.paused) || 0;
                if (!wanted) return rows;
                const created = (rows || []).filter((d: any) => d && d.type === 'product_view')[0];
                if (!created || !created.id) return rows;
                return axios.put(`${config.serviceUrl}/destination/${created.id}`, { ...body, id: created.id })
                    .then(() => reload(dispatch));
            });
        });
    };
};

export const saveDestination = (destination: any, history: any) => {
    // SHIM for the deployed addDestination Lambda: its INSERT destructures api_key /
    // custom_properties from the RAW body (snake_case) while everything else goes
    // through toUnderscore — so camelCase-only payloads insert NULL for those two
    // columns on CREATE. Send duplicate snake_case keys so the destructure binds.
    // Harmless on UPDATE (toUnderscore maps both spellings to the same column).
    // Remove when the backend Lambda is fixed to read underscoreBody.api_key.
    destination = { ...destination, api_key: destination.apiKey, custom_properties: destination.customProperties };
    return (dispatch: any) => {
        // Returns the save promise so the modal can stay open and show an error
        // when the save fails (a rejected PUT/POST used to be silently dropped:
        // the modal closed, nothing was stored). The list reload afterwards is
        // best-effort and never turns a successful save into a failure.
        const reload = () => {
            dispatch({
                type: LOAD_DESTINATIONS,
                payload: null
            })
            axios.get(`${config.serviceUrl}/destinations`).then((response) => {
                dispatch({
                    type: LOAD_DESTINATIONS_SUCCESS,
                    payload: response.data.data
                })
            }).catch(() => { /* list refreshes on next load */ })
        };
        if (destination.id) {
            delete destination.triggerId;
            return axios.put(`${config.serviceUrl}/destination/${destination.id}`, destination).then((response) => {
                dispatch({
                    type: UPDATE_DESTINATION_SUCCESS,
                    payload: response
                })
                reload();
                return response;
            })
        }
        return axios.post(`${config.serviceUrl}/destination`, destination).then((response: any) => {
            dispatch({
                type: CREATE_DESTINATION_SUCCESS,
                payload: response
            })
            reload();
            return response;
        })
    }
}
